import { render, staticRenderFns } from "./Company-Registration-Form.vue?vue&type=template&id=461f11e5"
import script from "./Company-Registration-Form.vue?vue&type=script&lang=js"
export * from "./Company-Registration-Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports